module.exports = __webpack_public_path__ + "img/booook.9db2fd0d.svg";